
import { ActionType } from '../constants/ActionTypes'

export default function promoToolReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.GET_PROMO_BEGIN:
            return {
                ...state,
                isLoading: true,
                data: null,
            }
        case ActionType.GET_PROMO_ERROR:
            return {
                ...state,
                error: true,
                isLoading: false,
            }
        case ActionType.GET_PROMO_SUCCESS:
            return {
                ...state,
                data: action.payload,
                isLoading: false,
            }

        case ActionType.GET_PROMO_PRIZE_BEGIN:
            return {
                ...state,
                isWinPrizeLoading: true,
                winPrize: {},
            }
        case ActionType.GET_PROMO_PRIZE_ERROR:
            return {
                ...state,
                isWinPrizeLoading: false,
            }
        case ActionType.GET_PROMO_PRIZE_SUCCESS:
            return {
                ...state,
                winPrize: action.payload,
                isWinPrizeLoading: false,
            }

        case ActionType.GET_PROMO_WINNINGS_BEGIN:
            return {
                ...state,
                winnings: {
                    ...state.winnings,
                    [action.payload.type]: [],
                },
                isWinningsLoading: true
            }
        case ActionType.GET_PROMO_WINNINGS_ERROR:
            return {
                ...state,
                isWinningsLoading: false
            }
        case ActionType.GET_PROMO_WINNINGS_SUCCESS:
            return {
                ...state,
                winnings: {
                    ...state.winnings,
                    [action.payload.type]: action.payload.data,
                },
                isWinningsLoading: false
            }
        case ActionType.GET_PROMO_BALANCE_BEGIN:
            return {
                ...state,
                isBalanceLoading: true
            }
        case ActionType.GET_PROMO_BALANCE_ERROR:
            return {
                ...state,
                isBalanceLoading: false
            }
        case ActionType.GET_PROMO_BALANCE_SUCCESS:
            return {
                ...state,
                balance: {
                    ...state.balance,
                    ...action.payload,
                },
                isBalanceLoading: false
            }
        case ActionType.GET_PROMO_BALANCE_INFO_BEGIN:
            return {
                ...state,
                isBalanceInfoLoading: true
            }
        case ActionType.GET_PROMO_BALANCE_INFO_ERROR:
            return {
                ...state,
                isBalanceInfoLoading: false
            }
        case ActionType.GET_PROMO_BALANCE_INFO_SUCCESS:
            return {
                ...state,
                balanceInfo: {
                    ...state.balanceInfo,
                    ...action.payload,
                },
                isBalanceInfoLoading: false
            }
        case ActionType.GET_PROMO_SPIN_DATE_BEGIN:
            return {
                ...state,
                isDateLoading: true
            }
        case ActionType.GET_PROMO_SPIN_DATE_ERROR:
            return {
                ...state,
                isDateLoading: false
            }
        case ActionType.GET_PROMO_SPIN_DATE_SUCCESS:
            return {
                ...state,
                spinDate: action.payload,
                isDateLoading: false
            }
        case ActionType.COLLECT_PROMO_SPINS_BEGIN:
            return {
                ...state,
                isCollectLoading: true
            }
        case ActionType.COLLECT_PROMO_SPINS_ERROR:
            return {
                ...state,
                isCollectLoading: false
            }
        case ActionType.COLLECT_PROMO_SPINS_SUCCESS:
            return {
                ...state,
                colectedSpins: action.payload,
                isCollectLoading: false
            }
        case ActionType.SET_PROMO_TOOL_SETTINGS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    ...action.payload
                }
            }
        case ActionType.GET_EXCHANGE_CENTER_BEGIN:
            return {
                ...state,
                exchangeCenter: {
                    isLoading: true,
                    data: {},
                }

            }
        case ActionType.GET_EXCHANGE_CENTER_ERROR:
            return {
                ...state,
              exchangeCenter: {
                    isLoading: false,
                    data: {},
                }
            }
        case ActionType.GET_EXCHANGE_CENTER_SUCCESS:
            return {
                ...state,
                exchangeCenter: {
                    isLoading: false,
                    data: action.payload,
                }
            }

        default:
            return state;
    }
}


